var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLearnerlight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 148,
    height: 148,
    viewBox: "0 0 148 148",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73.8953 147.791C114.707 147.791 147.791 114.707 147.791 73.8955C147.791 33.0843 114.707 0 73.8953 0C33.0841 0 0 33.0843 0 73.8955C0 114.707 33.0841 147.791 73.8953 147.791Z",
    fill: "url(#paint0_linear_7276_4151)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M102 113V49.3344L87.4184 35H46.069V113H102Z",
    fill: "white",
    stroke: "#D6D6D6",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M103 49.1724H87.8276V34L103 49.1724Z",
    fill: "#D6D6D6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3432 49.1724H68.5156V51.931H53.3432V49.1724Z",
    fill: "#6F6FF1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3473 58.8276H94.7266V61.5863H53.3473V58.8276Z",
    fill: "#D6D6D6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M53.0703 68H84.0703V71H53.0703V68Z",
    fill: "#E6E6E6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3473 78.1382H94.7266V80.8968H53.3473V78.1382Z",
    fill: "#D6D6D6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M53.0703 88H84.0703V91H53.0703V88Z",
    fill: "#E6E6E6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3473 97.4487H94.7266V100.207H53.3473V97.4487Z",
    fill: "#D6D6D6"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7276_4151",
    x1: 2.95582,
    y1: 3.10361,
    x2: 105.966,
    y2: 96.0639,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#525050",
    stopOpacity: 0.06
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLearnerlight);
export default __webpack_public_path__ + "static/media/learnerlight.6986127cfb7f6b546d809f86e57c8cf0.svg";
export { ForwardRef as ReactComponent };